import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Navigate, Outlet, Route } from 'react-router';
import { AuditLogsPage, ExportLogsModal } from '#route-bundles/authenticated.tsx';
import { NotFound } from '#screens/404/NotFound.tsx';
import { Oops } from '#screens/errors/Oops.tsx';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';
import { fromArray, page, Titled } from '#util/title.ts';

/**
 * {@link logsRootRoute} contains all of the routing config for the /logs path
 */
export const logsRootRoute = (
  <Route
    element={
      <Titled title={() => page('Audit logs')}>
        <Outlet />
      </Titled>
    }
  >
    {['audit', 'audit/export'].map((path) => (
      <Route
        key={path}
        path={path}
        element={
          <Suspense fallback={<LoadingSpinner />}>
            {/* Same dead-Refresh trap as the global boundary in App.tsx: remounting
                re-throws the cached query error, so only a reload moves forward. */}
            <ErrorBoundary fallbackRender={({ error }) => <Oops error={error as unknown} showErrorDetails={false} />}>
              <AuditLogsPage />
            </ErrorBoundary>
          </Suspense>
        }
      >
        <Route
          path="export"
          element={
            <Titled title={(title) => fromArray(['Export', title])}>
              <ExportLogsModal />
            </Titled>
          }
        />
      </Route>
    ))}
    <Route
      index={true}
      element={
        /* We only have /logs/audit right now, so redirect /logs there, for convenience */
        <Navigate to="/logs/audit/" replace={true} />
      }
    />
    <Route path="*" element={<NotFound />} />
  </Route>
);
